import { useState } from 'react';
import { parsePhoneNumber, isValidPhoneNumber } from 'libphonenumber-js';
import { VALIDATION } from '../config/constants';

// Tous les pays européens acceptés
const EUROPEAN_COUNTRIES = [
  'FI', 'SE', 'NO', 'DK', 'DE', 'FR', 'ES', 'IT', 'PT', 'NL',
  'BE', 'AT', 'CH', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'GR',
  'HR', 'SI', 'RS', 'BA', 'ME', 'MK', 'AL', 'XK', 'LT', 'LV',
  'EE', 'IE', 'GB', 'IS', 'LU', 'MT', 'CY', 'MD', 'UA', 'BY'
];

export const useFormValidation = (t, currentLanguage) => {
  const [validationErrors, setValidationErrors] = useState({});

  const validateEmail = (email) => {
    return VALIDATION.EMAIL_REGEX.test(email);
  };

  const validatePhone = (phone) => {
    if (!phone || !phone.trim()) return false;

    try {
      // 1. Essai avec le numéro tel quel (format international +XX)
      if (isValidPhoneNumber(phone)) {
        return true;
      }

      // 2. Essai avec chaque pays européen
      for (const country of EUROPEAN_COUNTRIES) {
        try {
          if (isValidPhoneNumber(phone, country)) {
            return true;
          }
        } catch (e) {}
      }

      // 3. Fallback : longueur basique
      const cleaned = phone.replace(/\D/g, '');
      return cleaned.length >= VALIDATION.PHONE_MIN_LENGTH &&
             cleaned.length <= VALIDATION.PHONE_MAX_LENGTH;

    } catch (error) {
      const cleaned = phone.replace(/\D/g, '');
      return cleaned.length >= VALIDATION.PHONE_MIN_LENGTH &&
             cleaned.length <= VALIDATION.PHONE_MAX_LENGTH;
    }
  };

  const formatPhoneNumber = (phone) => {
    try {
      // Essai format international direct
      if (phone.startsWith('+')) {
        const phoneNumber = parsePhoneNumber(phone);
        return phoneNumber ? phoneNumber.formatInternational() : phone;
      }
      // Essai avec pays par défaut FI
      const phoneNumber = parsePhoneNumber(phone, 'FI');
      return phoneNumber ? phoneNumber.formatInternational() : phone;
    } catch (error) {
      return phone;
    }
  };

  const validateForm = (formData) => {
    const errors = {};

    if (!formData.firstName?.trim()) errors.firstName = t.requiredField;
    if (!formData.lastName?.trim()) errors.lastName = t.requiredField;
    if (!formData.city?.trim()) errors.city = t.requiredField;
    if (!formData.income?.trim()) errors.income = t.requiredField;
    if (!formData.employment) errors.employment = t.requiredField;

    if (!formData.email?.trim()) {
      errors.email = t.requiredField;
    } else if (!validateEmail(formData.email)) {
      errors.email = t.invalidEmail;
    }

    if (!formData.phone?.trim()) {
      errors.phone = t.requiredField;
    } else if (!validatePhone(formData.phone)) {
      errors.phone = t.invalidPhone;
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const isFormValid = (formData) => {
    return Object.values(formData).every(value => value?.trim() !== '') &&
           validateEmail(formData.email) &&
           validatePhone(formData.phone);
  };

  const clearError = (fieldName) => {
    setValidationErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[fieldName];
      return newErrors;
    });
  };

  return {
    validationErrors,
    validateForm,
    isFormValid,
    clearError,
    validateEmail,
    validatePhone,
    formatPhoneNumber
  };
};